function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Filters_icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ToDoList_Dashboard",
  transform: "translate(-38.000000, -323.000000)",
  strokeWidth: 1.05
}, React.createElement("g", {
  id: "Sidebar"
}, React.createElement("g", {
  id: "Filters",
  transform: "translate(38.000000, 321.000000)"
}, React.createElement("g", {
  id: "Filters_icon",
  transform: "translate(0.000000, 2.000000)"
}, React.createElement("rect", {
  id: "Rectangle-Copy-10",
  x: 0.525,
  y: 0.525,
  width: 14.95,
  height: 11.95,
  rx: 4,
  className: "iconStroke"
}), React.createElement("path", {
  d: "M15.075,5.04642857 L11.2,5.04642857 C10.1851768,5.04642857 9.26642677,4.63509019 8.60138258,3.97004599 C7.93633839,3.3050018 7.525,2.3862518 7.525,1.37142857 L7.525,0.525 L11.4,0.525 C12.4148232,0.525 13.3335732,0.936338386 13.9986174,1.60138258 C14.6636616,2.26642677 15.075,3.18517677 15.075,4.2 L15.075,5.04642857 Z",
  id: "Rectangle-Copy-11",
  className: "iconFill"
}))))));

var SvgFiltersIcon = function SvgFiltersIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFiltersIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Filters_icon.3204fbd7.svg";
export { ForwardRef as ReactComponent };